import { render, staticRenderFns } from "./JsonEditForm.vue?vue&type=template&id=0b95c6cd&scoped=true"
import script from "./JsonEditForm.vue?vue&type=script&lang=js"
export * from "./JsonEditForm.vue?vue&type=script&lang=js"
import style0 from "./JsonEditForm.vue?vue&type=style&index=0&id=0b95c6cd&prod&lang=scss"
import style1 from "./JsonEditForm.vue?vue&type=style&index=1&id=0b95c6cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b95c6cd",
  null
  
)

export default component.exports